import React, { useContext, useState } from 'react';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { Menu as HUIMenu, Transition } from '@headlessui/react';
import { cn } from '#lib/helpers/class';
import { getPopInProps } from '#lib/helpers/transition';
const transition = getPopInProps();
import { UserContext } from '#src/index.jsx';
import { Icon } from '@iconify-icon/react/dist/iconify.js';

function Menu(props) {
    const { changeLanguage, getLanguage } = useContext(UserContext);
    const language = getLanguage();
    const options = INTL_LANGS.split(',');
    const [lang, setLanguage] = useState(language ?? navigator.language.split('-')[0]);
    const onChange = (value) => {
        setLanguage(value);
        changeLanguage(value);
    };

    const getIcon = (lang) => {
        switch (lang) {
            case 'it':
                return <Icon icon="twemoji:flag-italy" height="1.2rem" width="1.2rem" />;
            case 'en':
                return <Icon icon="twemoji:flag-united-kingdom" height="1.2rem" width="1.2rem" />;
            case 'ru':
                return <Icon icon="twemoji:flag-russia" height="1.2rem" width="1.2rem" />;
            default:
                return null;
        }
    };

    return (
        <div className="relative flex-shrink-0">
            <HUIMenu.Button className="flex justify-center items-center mx-1 rounded-lg focus:outline-none w-14 h-8 hover:bg-neutral-100">
                <span className="sr-only">{_t.global.openMenu()}</span>
                <div className="flex justify-between gap-2 items-center">
                    {getIcon(lang)}
                    <span>{lang?.toUpperCase()}</span>
                </div>
            </HUIMenu.Button>
            <Transition as={React.Fragment} {...transition}>
                <HUIMenu.Items className="absolute mt-1 ml-14 -translate-x-full rounded-md border border-neutral-100 bg-white py-1 shadow-lg">
                    {options.map((item, i) => (
                        <HUIMenu.Item key={item}>
                            {({ active }) => (
                                <button
                                    className={cn(
                                        active && 'bg-primary-50',
                                        'text-right w-full block px-4 py-2 text-sm text-neutral-700 hover:text-primary-700'
                                    )}
                                    onClick={() => onChange(item)}
                                >
                                    <div className="flex justify-start gap-2">
                                        {getIcon(item)}
                                        <span>{item.toUpperCase()}</span>
                                    </div>
                                </button>
                            )}
                        </HUIMenu.Item>
                    ))}
                </HUIMenu.Items>
            </Transition>
        </div>
    );
}

export default function LanguageSelect(props) {
    return <HUIMenu>{({ open }) => <Menu isOpen={open} {...props} />}</HUIMenu>;
}
